import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Amerikkalainen jalkapallo",
    Baseball: "Baseball",
    Basketball: "Koripallo",
    Boxing: "Nyrkkeily",
    Chess: "Shakki",
    Cricket: "Kriketti",
    Darts: "Darts",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Jalkapallo",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Gaelilainen Jalkapallo",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Käsipallo",
    "Ice Hockey": "Jääkiekko",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Pöytätennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} voittaa",
    WinFirstRound: "{name} voittaa ensimmäisen kierroksen",
    FirstTouchdown: "{name} pisteet Touchdown ensimmäinen",
    FirstTry: "{name} pisteet Try ensimmäinen",
    TotalGoals: "{name} Maalit yhteensä",
    TotalRuns: "{name} Juoksut yhteensä",
    TotalPoints: "{name} Pisteet yhteensä",
    TopBatsman: "{name} on paras lyöjä",
    TopBowler: "{name} on paras Bowler",
    FirstScore: "{name} tekee maalin ensimmäisenä"
  },
  PromoTexts: {
    Pick: "Tee valintasi",
    Bet: "Veto",
    Pays: "Voitto"
  },
  DateTimeTexts: {
    Today: "Tänään",
    Tomorrow: "Huomenna",
    Live: "Elävä"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Tee valintasi",
    Return: "Voitto",
    Stake: "Veto",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Tehdyt maalit",
    Shots: "Laukaukset",
    "Shots on target": "Laukaukset kohti maalia",
    "Ball possession": "Pallonhallinta",
    "Goals conceded": "Päästetyt maalit",
    "Per match": "Per ottelu",
    H2H: "H2H",
    W: "V",
    D: "T",
    L: "H"
  }
};
